import {Routes} from '@angular/router';

export const consumermerchantsRecommendationRoutes: Routes = [
  {
    path: 'consumermerchantsRecommendation',
    loadComponent: () => import('./consumermerchants-recommendation.component').then(m => m.ConsumermerchantsRecommendationComponent),
    data: { title: '好掌柜橱窗' },
  },
];
